import { gql } from '@apollo/client';

export const GET_USER_ACCOUNT = gql`
  query UserAccount($id: ID!) {
    userAccount(id: $id) {
      id
      firstName
      lastName
      loginName
    }
  }
`;

export const SEARCH_USER_ACCOUNT = gql`
  query SearchUserAccounts($searchInput: SearchInput) {
    searchUserAccounts(searchInput: $searchInput) {
      items {
        id
        firstName
        lastName
        loginName
      }
    }
  }
`;

export const SUBSCRIPTION_USER_ACCOUNT_CREATED = gql`
  subscription userAccountCreated {
    userAccountCreated {
      userAccountId
    }
  }
`;
